import { MS_PER_DAY } from '../constants/app.constants';
import { AnalyticsGranularity, TimelinePoint } from '../types/analytics.types';

const START_OF_DAY = { hours: 0, minutes: 0, seconds: 0, ms: 0 } as const;
const END_OF_DAY = { hours: 23, minutes: 59, seconds: 59, ms: 999 } as const;

/**
 * Returns an ISO start-of-day timestamp for `days` ago, relative to `anchor`.
 */
export const isoDaysAgo = (days: number, anchor: Date = new Date()): string => {
  const d = new Date(anchor.getTime() - days * MS_PER_DAY);
  d.setHours(START_OF_DAY.hours, START_OF_DAY.minutes, START_OF_DAY.seconds, START_OF_DAY.ms);
  return d.toISOString();
};

export const endOfTodayIso = (anchor: Date = new Date()): string => {
  const d = new Date(anchor);
  d.setHours(END_OF_DAY.hours, END_OF_DAY.minutes, END_OF_DAY.seconds, END_OF_DAY.ms);
  return d.toISOString();
};

export const formatBucketLabel = (
  bucketIso: string,
  granularity: AnalyticsGranularity,
): string => {
  const d = new Date(bucketIso);
  switch (granularity) {
    case 'month':
      return d.toLocaleDateString(undefined, { month: 'short', year: '2-digit' });
    case 'week':
    case 'day':
    default:
      return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
  }
};

export const formatAbsoluteDate = (iso: string): string =>
  new Date(iso).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

export const maxTimelineValue = (points: TimelinePoint[]): number => {
  let max = 0;
  for (const p of points) {
    const total = p.created + p.updated;
    if (total > max) max = total;
  }
  return max;
};

export const sumSeries = (
  points: TimelinePoint[],
  key: 'created' | 'updated',
): number => points.reduce((acc, p) => acc + p[key], 0);

export const getInitials = (name: string): string => {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};
